// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__DZk78","requiredAsterisk":"Info_requiredAsterisk__2Zj_A"};